import React from 'react'
import GalleryComponent from '../../components/GalleryComponent/GalleryComponent'
import SafariBlog from '../../components/SafariBlog/SafariBlog'

import gallery_1 from '../../assets/images/yala-1.jpg'
import gallery_2 from '../../assets/images/yala-2.jpg'
import gallery_3 from '../../assets/images/yala-3.jpg'
import gallery_4 from '../../assets/images/yala-4.webp'
import gallery_5 from '../../assets/images/yala-5.webp'
import gallery_6 from '../../assets/images/yala-6.webp'
import gallery_7 from '../../assets/images/yala-7.jpg'
import gallery_8 from '../../assets/images/yala-8.webp'
import gallery_9 from '../../assets/images/yala-9.jpg'
import gallery_10 from '../../assets/images/yala-10.jpg'


const descriptions = [
    'Yala National Park is located on the southeastern coast of Sri Lanka and is known for its rich variety of plants and animals. It covers a huge area of 979 square kilometers, making it the oldest and second-largest national park in Sri Lanka. People from all over the world who love nature and wildlife come here to explore.',

    'Yala has many different kinds of habitats, from dense forests during the rainy season to dry plains. This variety supports a wide range of plants and animals. The park is famous for its large population of Sri Lankan elephants, which you can see moving gracefully around. But the real highlight of Yala is the elusive Sri Lankan leopard, making it one of the best places in the world to spot these beautiful big cats. Seeing them in their natural home is an amazing experience, and the park’s terrain makes it likely you’ll have a chance to see them.',

    'Apart from leopards and elephants, Yala is home to many other animals like sloth bears, different kinds of deer, wild boars, and water buffaloes. It’s also a paradise for bird watchers, with over 200 species of birds, including some that only live in Sri Lanka and others that visit during the winter.',

    'As you explore Yala, you’ll come across peaceful lakes and waterholes where birds gather and animals come to drink. The park also has historical and archaeological sites, like the ancient Sithulpawwa Rock Temple, which adds a cultural dimension to your wildlife experience.',

    'Seeing a leopard in the wild or the peaceful moments by a quiet waterhole, visiting Yala promises an immersive and enriching experience with nature that will stay with you forever. So come and experience the wonders of nature at Yala National Park, where every safari brings a new adventure in the fascinating story of wildlife.',
  ];

const wildlife_photography = () => {

    const items = [
        { xs: 6, imgSrc: gallery_1 },
        { xs: 6, imgSrc: gallery_2 },
        { xs: 5, imgSrc: gallery_3 },
        { xs: 3, imgSrc: gallery_4 },
        { xs: 4, imgSrc: gallery_5 },
        { xs: 2.5, imgSrc: gallery_6 },
        { xs: 5.5, imgSrc: gallery_7 },
        { xs: 4, imgSrc: gallery_8 },
        { xs: 6.5, imgSrc: gallery_9 },
        { xs: 5.5, imgSrc: gallery_10 },
    ];

  return <div className='__black'>
    <SafariBlog
        heading='Yala National Park'
        description={descriptions}
        to='/contact'
    />
    <div className="w-1">
        <GalleryComponent imgStyle={{padding:'10px', height:'50vh'}} items={items} />;
    </div>
  </div>
}

export default wildlife_photography